import { ref } from 'vue'
import { api } from '@/global/services/api'

export function useAutocompletes () {
  const roadTypes = ref([])

  const fetchRoadTypes = async () => {
    try {
      const { data } = await api('road-maintenance').get('codebook', {
        types: ['ROAD_TYPE']
      })

      roadTypes.value = data?.road_type?.length
        ? data.road_type
        : []
    }
    catch (e) {
      console.error(e)
    }
  }

  return {
    roadTypes,
    fetchRoadTypes
  }
}
